export default "__VITE_ASSET__CXq5MymD__"